import palmBeach from "../assets/art/palm-beach.jpg";
import heron from "../assets/art/heron.jpg";
import riverSunset from "../assets/art/river-sunset.jpg";
import flowersVase from "../assets/art/flowers-vase.jpg";
import penguins from "../assets/art/penguins.jpg";
import hedgehog from "../assets/art/hedgehog.jpg";
import gnome from "../assets/art/gnome.jpg";
import pineapple from "../assets/art/pineapple.jpg";

/** Bundled starter images, resolved at render time by `seedKey`. */
export const SEED_IMAGES: Record<string, string> = {
  "palm-beach": palmBeach,
  heron,
  "river-sunset": riverSunset,
  "flowers-vase": flowersVase,
  penguins,
  hedgehog,
  gnome,
  pineapple,
};
